import { qs } from "@fluorescent/dom";

const selectors = {
  productSku: "[data-product-sku]",
};

const {
  strings: { products: strings },
} = window.theme;

export default function (container, variant) {
  const skuElement = qs(selectors.productSku, container);

  if (!skuElement) return;

  const { sku } = strings.product;
  const skuString = value => `${sku}: ${value}`;

  if (!variant || !variant.sku) {
    skuElement.innerText = "";
    return;
  }

  skuElement.innerText = skuString(variant.sku);
}
